import { useEffect } from "react";
import { driver } from "driver.js";
import "driver.js/dist/driver.css";


export default function GuidedTour({ run, onFinish }) {
  useEffect(() => {
    if (!run) return;

    const tour = driver({
      animate: true,
      showProgress: true,
      overlayOpacity: 0.7,
      allowClose: true,
      stagePadding: 10,
      nextBtnText: "Next",
      prevBtnText: "Back",
      doneBtnText: "Finish",

      steps: [
        {
            element: "#account-menu",
            popover: {
                title: "Account Menu",
                description: "Click to open language & theme options.",
                side: "bottom",
                align: "start",
            }
        },
        {
          element: "#departments",
          popover: {
            title: "Classrooms",
            description: "you can find your assigned classrooms here",
            side: "right",
            align: "center",
          },
        }
      ],
      onDestroyStarted: () => {
        tour.destroy(); 
        onFinish();
      },
      onDestroyed: () => {
        onFinish();
      },
    });

    tour.drive();

  }, [run, onFinish]);

  return null;
}